import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import {refreshDashboards} from 'common/src/modules/campaigns/store/insightsPage/features';
import createNavigateToCampaignWorkflowStep from 'common/src/modules/campaigns/utils/createNavigateToCampaignWorkflowStep';
import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import {CONTROL_MODE} from 'common/src/modules/decisionTree/decisionTree.consts';
import {DTControlMode} from 'common/src/modules/decisionTree/treeTypes';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

const inputSchema = z.object({
  dashboardId: z.number().describe('The ID of the dashboard to delete'),
});

function deleteDashboardTool(store: CLStore) {
  async function execute({
    input: {dashboardId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const state = store.getState();
    const {
      campaignPage: {
        campaignTree: {
          campaign: {id: campaignId},
          versionNumber,
        },
      },
    } = state;

    await campaignsApi.removeCampaignDashboard(campaignId, dashboardId);
    store.dispatch(refreshDashboards());

    const {id} = await campaignsApi.getCampaignDefaultDashboard(campaignId);

    if (dashboardId === id) {
      const queryParams = {
        ...Object.fromEntries(new URLSearchParams(document.location.search).entries()),
      };
      // After deleting a dashboard, we need to navigate to  default dashboard
      createNavigateToCampaignWorkflowStep(CampaignStep.Insights)({
        campaignId,
        versionNumber: versionNumber.toString(),
        queryParams: {
          ...queryParams,
          [CONTROL_MODE]: DTControlMode.AnalyticsDashboard,
          dashboardId: id,
        },
      });
    }

    return toolResult('Success');
  }

  return tool({
    name: CampaignAnalyticsToolName.DeleteDashboard,
    displayName: 'Deleting dashboard',
    description: 'delete a dashboard',
    execute,
    inputSchema,
  });
}

export default deleteDashboardTool;
